<div class="modal" [class.show]="isModalOpen">
  <div id="print-section" class="modal-content" #modalContent>
    <div class="modal-header">
      <h2>{{ config.terms.title }}</h2>
    </div>
    <div class="modal-body">
      <div
        id="terms-text"
        #terms
        tabindex="0"
        class="terms-content scrollable-content"
        [innerHTML]="termsText()"
        #scrollElement
        (scroll)="onScroll()"
      ></div>
    </div>

    <div
      *ngIf="rejected"
      class="rejected-warning"
      [innerHTML]="rejectWarning()"
    ></div>

    <div class="modal-footer">
      <app-web-button
        [id]="'terms-accept'"
        [label]="config.terms.acceptBtnLabel"
        [data]="'acceptTerms'"
        [style]="'white'"
        (clicked)="onAccept()"
        [disabled]="isButtonDisabled"
      ></app-web-button>
      <app-web-button
        *ngIf="!rejected"
        [id]="'terms-reject'"
        [label]="config.terms.rejectBtnLabel"
        [data]="'rejectTerms'"
        [style]="'white'"
        (clicked)="onReject()"
        [disabled]="isButtonDisabled"
      ></app-web-button>
      <app-web-button
        id="btnClose"
        *ngIf="rejected"
        [id]="'terms-close'"
        [label]="config.terms.closeBtnLabel"
        [data]="config.terms.closeBtnLabel"
        [style]="'white'"
        (clicked)="onClose()"
      />
      <app-web-button
        id="btnPrint"
        [id]="'terms-print'"
        [label]="config.terms.printBtnLabel"
        [data]="config.terms.printBtnLabel"
        [style]="'white'"
        (clicked)="onPrint()"
      />
    </div>
  </div>
</div>
